/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SettingControllerSetSettlementConfig$Params {
      body: {

/**
 * 두당 사육관리비 (원)
 */
'farmManagementFeePerPig'?: number;

/**
 * 공모 수수료율
 */
'offeringFeeRate'?: number;

/**
 * 초과수익 수수료율
 */
'excessProfitFeeRate'?: number;

/**
 * 기준 수익률
 */
'excessProfitThreshold'?: number;

/**
 * 소득세율
 */
'incomeTaxRate'?: number;

/**
 * 지방소득세율
 */
'localTaxRate'?: number;
}
}

export function settingControllerSetSettlementConfig(http: HttpClient, rootUrl: string, params: SettingControllerSetSettlementConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, settingControllerSetSettlementConfig.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

settingControllerSetSettlementConfig.PATH = '/api/setting/settlement-config';
